import { listMyOrgs } from "../lib/api.js";
import { loadAuth, saveAuth } from "../lib/auth.js";

export async function orgListCommand(): Promise<void> {
  const orgs = await listMyOrgs();
  if (orgs.length === 0) {
    console.log("No organizations.");
    return;
  }
  const auth = loadAuth();
  const nameWidth = Math.max(4, ...orgs.map((o) => o.name.length));
  const slugWidth = Math.max(4, ...orgs.map((o) => o.slug.length));
  console.log(`${"Name".padEnd(nameWidth)}  ${"Slug".padEnd(slugWidth)}  Role     Active`);
  console.log(`${"─".repeat(nameWidth)}  ${"─".repeat(slugWidth)}  ───────  ──────`);
  for (const o of orgs) {
    const active = auth?.org_id === o.id ? "  *" : "";
    console.log(
      `${o.name.padEnd(nameWidth)}  ${o.slug.padEnd(slugWidth)}  ${o.role.padEnd(7)}${active}`
    );
  }
}

export async function orgUseCommand(slugOrId: string): Promise<void> {
  const orgs = await listMyOrgs();
  const match = orgs.find((o) => o.id === slugOrId || o.slug === slugOrId);
  if (!match) {
    console.error(
      `No org matched "${slugOrId}". Available: ${orgs.map((o) => o.slug).join(", ")}`
    );
    process.exit(1);
  }
  const auth = loadAuth();
  if (!auth) {
    console.error("Not logged in. Run `clawnify login` first.");
    process.exit(1);
  }
  saveAuth({ ...auth, org_id: match.id });
  console.log(`  Active org set to ${match.name} (${match.slug})`);
}
